import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { ApiApprovalRequest } from '../../types/apis'

const { APIS_API_URL } = CONSTANT

const acceptApi = async (apiApproval: ApiApprovalRequest): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${APIS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'APPROVE'
		},
		body: JSON.stringify(apiApproval)
	})
	return response.json()
}

export default acceptApi
